module.exports = __webpack_public_path__ + "static/media/common-entrance.9b66adc3.jpg";